import { render, staticRenderFns } from "./userHead.vue?vue&type=template&id=02fba0d0&scoped=true"
import script from "./userHead.vue?vue&type=script&lang=js"
export * from "./userHead.vue?vue&type=script&lang=js"
import style0 from "./userHead.vue?vue&type=style&index=0&id=02fba0d0&prod&lang=scss"
import style1 from "./userHead.vue?vue&type=style&index=1&id=02fba0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fba0d0",
  null
  
)

export default component.exports